import { createContext, useContext } from 'react';
import { useCreateTerminKalenderForm } from '@/domain/termine/features/CreateTerminKalender/shared/hooks/useCreateTerminKalenderForm';

type CreateTerminKalenderFormContextType = ReturnType<
  typeof useCreateTerminKalenderForm
>;

export const CreateTerminKalenderFormContext =
  createContext<CreateTerminKalenderFormContextType | null>(null);

export function useCreateTerminKalenderFormContext() {
  const ctx = useContext(CreateTerminKalenderFormContext);
  if (!ctx) throw new Error('Missing CreateTerminKalenderFormContext');
  return ctx;
}
